import { FormattedMessage } from 'locales/index'
import React, { ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLeaf } from '@fortawesome/free-solid-svg-icons'
import { Typography } from '@commutifi-fe/ui'
import IconMap from 'static/icons/icon-map.svg'
import IconSmiley from 'static/icons/icon-smiley.svg'
import IconWallet from 'static/icons/icon-wallet.svg'
import styles from './styles.module.scss'
import { colors } from 'constants/global'

const { Text } = Typography
interface CommutifiBenefitItemProps {
  title: React.ReactNode
  description: React.ReactNode
  icon: string | ReactNode
  benefitName: string
  iconBackgroundColor?: string
}

function CommutifiBenefitItem({
  title,
  description,
  icon,
  benefitName,
  iconBackgroundColor
}: CommutifiBenefitItemProps) {
  return (
    <div id={benefitName} className={styles['benefit-item']}>
      <div className={styles['benefit-image']} style={{ backgroundColor: iconBackgroundColor }}>
        {typeof icon === 'string' ? <img src={icon} alt={benefitName} /> : icon}
      </div>
      <div>
        <Text strong="semi-bold" size="lead" block>
          {title}
        </Text>
        <Text type="secondary">{description}</Text>
      </div>
    </div>
  )
}

const CommutifiBenefit = ({ children }: { children: React.ReactNode }) => children

function Understand({ title, description, icon, benefitName }: Partial<CommutifiBenefitItemProps>) {
  return (
    <CommutifiBenefitItem
      title={title || <FormattedMessage id="intro.understand.title" />}
      description={description || <FormattedMessage id="intro.understand.description" />}
      icon={icon || IconMap}
      benefitName={benefitName || 'Understand'}
    />
  )
}
CommutifiBenefit.Understand = Understand

function Improve({ title, description, icon, benefitName }: Partial<CommutifiBenefitItemProps>) {
  return (
    <CommutifiBenefitItem
      title={title || <FormattedMessage id="intro.improve.title" />}
      description={description || <FormattedMessage id="intro.improve.description" />}
      icon={icon || IconSmiley}
      benefitName={benefitName || 'Improve'}
    />
  )
}
CommutifiBenefit.Improve = Improve

function SaveMoney({ title, description, icon, benefitName }: Partial<CommutifiBenefitItemProps>) {
  return (
    <CommutifiBenefitItem
      title={title || <FormattedMessage id="intro.saveMoney.title" />}
      description={description || <FormattedMessage id="intro.saveMoney.description" />}
      icon={icon || IconWallet}
      benefitName={benefitName || 'Save Money'}
    />
  )
}
CommutifiBenefit.SaveMoney = SaveMoney

function Sustainability({ title, description, icon, benefitName }: Partial<CommutifiBenefitItemProps>) {
  return (
    <CommutifiBenefitItem
      title={title || <FormattedMessage id="intro.sustainability.title" />}
      description={description || <FormattedMessage id="intro.sustainability.description" />}
      icon={icon || <FontAwesomeIcon icon={faLeaf} color={colors.accentGreen500} size="lg" />}
      benefitName={benefitName || 'Sustainability'}
      iconBackgroundColor={colors.accentGreen100}
    />
  )
}
CommutifiBenefit.Sustainability = Sustainability

export { CommutifiBenefit }
